import { IStyles } from '@wix/tpa-settings';
import React from 'react';

export const AllBreakpointsStylesContext = React.createContext<IStyles[]>(
  [] as IStyles[],
);

export const AllBreakpointsStylesConsumer = AllBreakpointsStylesContext.Consumer;
export const AllBreakpointsStylesProvider = AllBreakpointsStylesContext.Provider;

export const useAllBreakpointsStyles = () =>
  React.useContext(AllBreakpointsStylesContext);
